$(document).ready(function () {
    $('.resources-content').on('click', '.popover-close', function () {
        var popoverID = '#' + $(this).data('popover');
        $(popoverID).popover('hide');
    });

    $('.show-resource-settings').click(function () {
        $('.show-resource-settings').popover('destroy');
        $(this).popover('show');
        var timeout;
        timeout = setTimeout(function () {
            $('.show-resource-settings').popover('destroy');
        }, 10000);
        $('.popover').mouseleave(function () {
            timeout = setTimeout(function () {
                $('.show-resource-settings').popover('destroy');
            }, 10000);
        });
        $('.popover').mouseenter(function (event) {
            clearTimeout(timeout);
        });
    });

    $('#resource-filter-button').on('click', function () {
        $('.resource-filter').slideToggle();
    });
});
